"use strict";
import {resolvers} from "Subschema";
const {loadOperator} = resolvers.operator;
export const settings = {
    type: "operator",
    operator: "truthy"
};
export default function operator$config(options) {
    options = {...settings, ...options};
    if (!options.message) throw new Error('Option requires a message');
    const operatorFunc = loadOperator(options.operator, null, null, {loader: this});

    return function operator$validator(val, valueManger) {
        const compareTo = options.listen ? valueManger.path(options.listen) : null;
        if (operatorFunc(val, compareTo)) {
            const {listen, operator, ...rest} = options;
            return rest;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/validators/operator.js
 **/